import { styled, css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { colors } }) => css`
    display: flex;
    padding: 0.5rem;

    .active {
      background: ${colors.brandPrimaryAlpha5};
      color: ${colors.brandPrimary};

      &:hover {
        background: ${colors.brandPrimaryAlpha5};
        color: ${colors.brandPrimary};
      }
    }

    @media print {
      display: none;
    }
  `}
`;
